import React, { useState } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import SignIn from '../components/SignIn.jsx';
import SignUp from '../components/SignUp.jsx';
import backgroundWavey from '../assets/Wavey-Fingerprint.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 1,
  },

  backgroundImage: {
    position: 'fixed',
    left: 0,
    right: 0,
    zIndex: 0,
    backgroundImage: `url(${backgroundWavey})`,
    width: '100%',
    height: '100%',
    display: 'block',
    // filter: 'blur(5px)',
  },
}));

const SignupSignIn = () => {
  const location = useLocation();
  const classes = useStyles();
  const [showSignIn, setShowSignIn] = useState(true);

  const changeShowSignIn = () => {
    setShowSignIn(!showSignIn);
  };

  return (
    <div>
      <div className={classes.backgroundImage}></div>
      <Container maxWidth='md' className={classes.root}>
        {showSignIn && (
          <SignIn
            lang={location.state.lang}
            handleShowSignIn={changeShowSignIn}
          />
        )}
        {!showSignIn && (
          <SignUp
            lang={location.state.lang}
            handleShowSignIn={changeShowSignIn}
          />
        )}
      </Container>
    </div>
  );
};

export default SignupSignIn;
